export const TKeyCallAnalysis = {
  CALL_ANALYSIS_SEO_TITLE: "CALL_ANALYSIS_SEO_TITLE",
  CALL_ANALYSIS_TITLE: "CALL_ANALYSIS_TITLE",
  CALL_ANALYSIS_SUBTITLE: "CALL_ANALYSIS_SUBTITLE",
  CALL_ANALYSIS_NEXT_OFFER_TITLE: "CALL_ANALYSIS_NEXT_OFFER_TITLE",
  CALL_ANALYSIS_NEXT_OFFER_DESCRIPTION: "CALL_ANALYSIS_NEXT_OFFER_DESCRIPTION",
  CALL_ANALYSIS_NEXT_OFFER_CTA: "CALL_ANALYSIS_NEXT_OFFER_CTA",
  CALL_ANALYSIS_RUN_CONFIRM_TITLE: "CALL_ANALYSIS_RUN_CONFIRM_TITLE",
  CALL_ANALYSIS_RUN_CONFIRM_NOTE: "CALL_ANALYSIS_RUN_CONFIRM_NOTE",
  CALL_ANALYSIS_RUN_CONFIRM_CTA: "CALL_ANALYSIS_RUN_CONFIRM_CTA",
  CALL_ANALYSIS_DROP_TITLE: "CALL_ANALYSIS_DROP_TITLE",
  CALL_ANALYSIS_DROP_SUBTITLE: "CALL_ANALYSIS_DROP_SUBTITLE",
  CALL_ANALYSIS_DROP_OR: "CALL_ANALYSIS_DROP_OR",
  CALL_ANALYSIS_BROWSE: "CALL_ANALYSIS_BROWSE",
  CALL_ANALYSIS_FORMATS: "CALL_ANALYSIS_FORMATS",
  CALL_ANALYSIS_MAX_SIZE: "CALL_ANALYSIS_MAX_SIZE",
  CALL_ANALYSIS_INTEGRATIONS_TITLE: "CALL_ANALYSIS_INTEGRATIONS_TITLE",
  CALL_ANALYSIS_IMPORT_LINK_TITLE: "CALL_ANALYSIS_IMPORT_LINK_TITLE",
  CALL_ANALYSIS_IMPORT_LINK_SUBTITLE: "CALL_ANALYSIS_IMPORT_LINK_SUBTITLE",
  CALL_ANALYSIS_IMPORT_LINK_INPUT: "CALL_ANALYSIS_IMPORT_LINK_INPUT",
  CALL_ANALYSIS_IMPORT_LINK_BTN: "CALL_ANALYSIS_IMPORT_LINK_BTN",
  CALL_ANALYSIS_IMPORT_LINK_SUBMIT: "CALL_ANALYSIS_IMPORT_LINK_SUBMIT",
  CALL_ANALYSIS_IMPORT_LINK_INVALID: "CALL_ANALYSIS_IMPORT_LINK_INVALID",
  CALL_ANALYSIS_LIBRARY_TITLE: "CALL_ANALYSIS_LIBRARY_TITLE",
  CALL_ANALYSIS_LIBRARY_EMPTY: "CALL_ANALYSIS_LIBRARY_EMPTY",
  CALL_ANALYSIS_LIBRARY_EMPTY_SUB: "CALL_ANALYSIS_LIBRARY_EMPTY_SUB",
  CALL_ANALYSIS_LIBRARY_EMPTY_SUB_READER: "CALL_ANALYSIS_LIBRARY_EMPTY_SUB_READER",
  CALL_ANALYSIS_LIBRARY_NO_RESULTS: "CALL_ANALYSIS_LIBRARY_NO_RESULTS",
  CALL_ANALYSIS_LIBRARY_TOTAL: "CALL_ANALYSIS_LIBRARY_TOTAL",
  CALL_ANALYSIS_FILTER_ALL: "CALL_ANALYSIS_FILTER_ALL",
  CALL_ANALYSIS_PERIOD_ALL: "CALL_ANALYSIS_PERIOD_ALL",
  CALL_ANALYSIS_PERIOD_7_DAYS: "CALL_ANALYSIS_PERIOD_7_DAYS",
  CALL_ANALYSIS_PERIOD_30_DAYS: "CALL_ANALYSIS_PERIOD_30_DAYS",
  CALL_ANALYSIS_PERIOD_90_DAYS: "CALL_ANALYSIS_PERIOD_90_DAYS",
  CALL_ANALYSIS_PERIOD_12_MONTHS: "CALL_ANALYSIS_PERIOD_12_MONTHS",
  CALL_ANALYSIS_PERIOD_THIS_YEAR: "CALL_ANALYSIS_PERIOD_THIS_YEAR",
  CALL_ANALYSIS_PERIOD_CUSTOM: "CALL_ANALYSIS_PERIOD_CUSTOM",
  CALL_ANALYSIS_PERIOD_FROM: "CALL_ANALYSIS_PERIOD_FROM",
  CALL_ANALYSIS_PERIOD_TO: "CALL_ANALYSIS_PERIOD_TO",
  CALL_ANALYSIS_COL_NAME: "CALL_ANALYSIS_COL_NAME",
  CALL_DELETE_TITLE: "CALL_DELETE_TITLE",
  CALL_DELETE_TEXT: "CALL_DELETE_TEXT",
  CALL_DELETE_TEXT_ANALYZED: "CALL_DELETE_TEXT_ANALYZED",
  CALL_DELETE_CONFIRM: "CALL_DELETE_CONFIRM",
  CALL_ANALYSIS_COL_SIZE: "CALL_ANALYSIS_COL_SIZE",
  CALL_ANALYSIS_COL_STATUS: "CALL_ANALYSIS_COL_STATUS",
  CALL_ANALYSIS_STATUS_UPLOADING: "CALL_ANALYSIS_STATUS_UPLOADING",
  CALL_ANALYSIS_STATUS_UPLOADED: "CALL_ANALYSIS_STATUS_UPLOADED",
  CALL_ANALYSIS_STATUS_ANALYZING: "CALL_ANALYSIS_STATUS_ANALYZING",
  CALL_ANALYSIS_STATUS_ANALYZED: "CALL_ANALYSIS_STATUS_ANALYZED",
  CALL_ANALYSIS_STATUS_FAILED: "CALL_ANALYSIS_STATUS_FAILED",
  CALL_ANALYSIS_LEVEL_LOW: "CALL_ANALYSIS_LEVEL_LOW",
  CALL_ANALYSIS_LEVEL_MEDIUM: "CALL_ANALYSIS_LEVEL_MEDIUM",
  CALL_ANALYSIS_LEVEL_HIGH: "CALL_ANALYSIS_LEVEL_HIGH",
  CALL_DETAIL_TYPE: "CALL_DETAIL_TYPE",
  CALL_DETAIL_TYPE_AUDIO: "CALL_DETAIL_TYPE_AUDIO",
  CALL_DETAIL_TYPE_VIDEO: "CALL_DETAIL_TYPE_VIDEO",
  CALL_DETAIL_TYPE_TRANSCRIPT: "CALL_DETAIL_TYPE_TRANSCRIPT",
  CALL_TYPE_LABEL: "CALL_TYPE_LABEL",
  CALL_TYPE_DISCOVERY: "CALL_TYPE_DISCOVERY",
  CALL_TYPE_DEMO: "CALL_TYPE_DEMO",
  CALL_TYPE_INTERVIEW: "CALL_TYPE_INTERVIEW",
  CALL_TYPE_CLOSING: "CALL_TYPE_CLOSING",
  CALL_TYPE_OTHER: "CALL_TYPE_OTHER",
  CALL_TYPE_NAME_LABEL: "CALL_TYPE_NAME_LABEL",
  CALL_TYPE_ADD: "CALL_TYPE_ADD",
  CALL_TYPE_ADD_PLACEHOLDER: "CALL_TYPE_ADD_PLACEHOLDER",
  CALL_TYPE_ADD_SUBMIT: "CALL_TYPE_ADD_SUBMIT",
  CALL_TYPE_EDIT: "CALL_TYPE_EDIT",
  CALL_TYPE_EDIT_SUBMIT: "CALL_TYPE_EDIT_SUBMIT",
  CALL_TYPE_DELETE: "CALL_TYPE_DELETE",
  CALL_TYPE_DELETE_WARNING: "CALL_TYPE_DELETE_WARNING",
  CALL_TYPE_DELETE_CONFIRM: "CALL_TYPE_DELETE_CONFIRM",
  CALL_DETAIL_ANALYSIS_ERROR_TITLE: "CALL_DETAIL_ANALYSIS_ERROR_TITLE",
  CALL_DETAIL_DELETE: "CALL_DETAIL_DELETE",
  CALL_ANALYSIS_INSIGHT_PAIN: "CALL_ANALYSIS_INSIGHT_PAIN",
  CALL_ANALYSIS_INSIGHT_PAIN_SUB: "CALL_ANALYSIS_INSIGHT_PAIN_SUB",
  CALL_ANALYSIS_INSIGHT_OBJECTION: "CALL_ANALYSIS_INSIGHT_OBJECTION",
  CALL_ANALYSIS_INSIGHT_OBJECTION_SUB: "CALL_ANALYSIS_INSIGHT_OBJECTION_SUB",
  CALL_ANALYSIS_INSIGHT_SIGNALS: "CALL_ANALYSIS_INSIGHT_SIGNALS",
  CALL_ANALYSIS_INSIGHT_SIGNALS_SUB: "CALL_ANALYSIS_INSIGHT_SIGNALS_SUB",
  CALL_ANALYSIS_INSIGHT_VERBATIMS: "CALL_ANALYSIS_INSIGHT_VERBATIMS",
  CALL_ANALYSIS_INSIGHT_VERBATIMS_SUB: "CALL_ANALYSIS_INSIGHT_VERBATIMS_SUB",
  CALL_ANALYSIS_INSIGHT_FEATURES: "CALL_ANALYSIS_INSIGHT_FEATURES",
  CALL_ANALYSIS_INSIGHT_FEATURES_SUB: "CALL_ANALYSIS_INSIGHT_FEATURES_SUB",
  CALL_ANALYSIS_INSIGHT_ACTIONS: "CALL_ANALYSIS_INSIGHT_ACTIONS",
  CALL_ANALYSIS_INSIGHT_ACTIONS_SUB: "CALL_ANALYSIS_INSIGHT_ACTIONS_SUB",
  CALL_ANALYSIS_INSIGHT_COMPETITORS: "CALL_ANALYSIS_INSIGHT_COMPETITORS",
  CALL_ANALYSIS_INSIGHT_COMPETITORS_SUB: "CALL_ANALYSIS_INSIGHT_COMPETITORS_SUB",
  CALL_ANALYSIS_RECO_CONNECT: "CALL_ANALYSIS_RECO_CONNECT",
  CALL_OVERVIEW_TYPES_TITLE: "CALL_OVERVIEW_TYPES_TITLE",
  CALL_OVERVIEW_MEMBERS_TITLE: "CALL_OVERVIEW_MEMBERS_TITLE",
  CALL_OVERVIEW_TEAM_AVERAGE: "CALL_OVERVIEW_TEAM_AVERAGE",
  CALL_OVERVIEW_KPI_QUESTIONS: "CALL_OVERVIEW_KPI_QUESTIONS",
  CALL_OVERVIEW_TOP_INSIGHTS_TITLE: "CALL_OVERVIEW_TOP_INSIGHTS_TITLE",
  CALL_OVERVIEW_TOP_PATTERNS_TITLE: "CALL_OVERVIEW_TOP_PATTERNS_TITLE",
  CALL_OVERVIEW_OF_CALLS: "CALL_OVERVIEW_OF_CALLS",
  CALL_ANALYSIS_TAB_OVERVIEW: "CALL_ANALYSIS_TAB_OVERVIEW",
  CALL_OVERVIEW_KPI_CALLS: "CALL_OVERVIEW_KPI_CALLS",
  CALL_OVERVIEW_KPI_DURATION: "CALL_OVERVIEW_KPI_DURATION",
  CALL_OVERVIEW_KPI_SCORE: "CALL_OVERVIEW_KPI_SCORE",
  CALL_OVERVIEW_TREND_HINT: "CALL_OVERVIEW_TREND_HINT",
  CALL_OVERVIEW_TIMELINE_TITLE: "CALL_OVERVIEW_TIMELINE_TITLE",
  CALL_OVERVIEW_SCORES_TITLE: "CALL_OVERVIEW_SCORES_TITLE",
  CALL_OVERVIEW_INSIGHTS_TITLE: "CALL_OVERVIEW_INSIGHTS_TITLE",
  CALL_OVERVIEW_EMPTY: "CALL_OVERVIEW_EMPTY",
  CALL_OVERVIEW_SCORE_PAIN: "CALL_OVERVIEW_SCORE_PAIN",
  CALL_OVERVIEW_SCORE_OBJECTION: "CALL_OVERVIEW_SCORE_OBJECTION",
  CALL_OVERVIEW_SCORE_BUYING_SIGNAL: "CALL_OVERVIEW_SCORE_BUYING_SIGNAL",
  CALL_OVERVIEW_SCORE_CONVERSATION_CLARITY: "CALL_OVERVIEW_SCORE_CONVERSATION_CLARITY",
  CALL_OVERVIEW_SCORE_PROSPECT_ENGAGEMENT: "CALL_OVERVIEW_SCORE_PROSPECT_ENGAGEMENT",
  CALL_OVERVIEW_SCORE_NEXT_STEP_CLARITY: "CALL_OVERVIEW_SCORE_NEXT_STEP_CLARITY",
  CALL_ANALYSIS_TAB_MARKET: "CALL_ANALYSIS_TAB_MARKET",
  CALL_ANALYSIS_TAB_PATTERNS: "CALL_ANALYSIS_TAB_PATTERNS",
  CALL_ANALYSIS_TAB_DYNAMICS: "CALL_ANALYSIS_TAB_DYNAMICS",
  CALL_EXPORT_ABOUT: "CALL_EXPORT_ABOUT",
  CALL_EXPORT_ANALYZED_CALLS: "CALL_EXPORT_ANALYZED_CALLS",
  CALL_EXPORT_CALLS_BY_TYPE: "CALL_EXPORT_CALLS_BY_TYPE",
  CALL_EXPORT_TOTAL_DURATION: "CALL_EXPORT_TOTAL_DURATION",
  CALL_EXPORT_SUMMARY: "CALL_EXPORT_SUMMARY",
  CALL_EXPORT_SCOPE: "CALL_EXPORT_SCOPE",
  CALL_EXPORT_SCOPE_NOTICE: "CALL_EXPORT_SCOPE_NOTICE",
  CALL_EXPORT_SCOPE_PERIOD: "CALL_EXPORT_SCOPE_PERIOD",
  CALL_EXPORT_SCOPE_MEMBER: "CALL_EXPORT_SCOPE_MEMBER",
  CALL_EXPORT_SCOPE_TYPE: "CALL_EXPORT_SCOPE_TYPE",
  CALL_EXPORT_SCOPE_RANGE: "CALL_EXPORT_SCOPE_RANGE",
  CALL_EXPORT_SCOPE_FROM: "CALL_EXPORT_SCOPE_FROM",
  CALL_EXPORT_SCOPE_TO: "CALL_EXPORT_SCOPE_TO",
  CALL_DETAIL_TAB_ABOUT: "CALL_DETAIL_TAB_ABOUT",
  CALL_DETAIL_TAB_SUMMARY: "CALL_DETAIL_TAB_SUMMARY",
  CALL_DETAIL_TAB_PAIN: "CALL_DETAIL_TAB_PAIN",
  CALL_DETAIL_TAB_OBJECTIONS: "CALL_DETAIL_TAB_OBJECTIONS",
  CALL_DETAIL_TAB_SIGNALS: "CALL_DETAIL_TAB_SIGNALS",
  CALL_DETAIL_TAB_VERBATIMS: "CALL_DETAIL_TAB_VERBATIMS",
  CALL_DETAIL_TAB_PRODUCT: "CALL_DETAIL_TAB_PRODUCT",
  CALL_DETAIL_TAB_COMPETITORS: "CALL_DETAIL_TAB_COMPETITORS",
  CALL_DETAIL_MEDIA_PREVIEW: "CALL_DETAIL_MEDIA_PREVIEW",
  CALL_DETAIL_MEDIA_UNSUPPORTED: "CALL_DETAIL_MEDIA_UNSUPPORTED",
  CALL_DETAIL_MEDIA_DOWNLOAD: "CALL_DETAIL_MEDIA_DOWNLOAD",
  CALL_DETAIL_NOTE: "CALL_DETAIL_NOTE",
  CALL_DETAIL_NOTE_PLACEHOLDER: "CALL_DETAIL_NOTE_PLACEHOLDER",
  CALL_DETAIL_MEDIA_BROWSER_ERROR: "CALL_DETAIL_MEDIA_BROWSER_ERROR",
  CALL_DETAIL_ANALYSIS_RUN: "CALL_DETAIL_ANALYSIS_RUN",
  CALL_DETAIL_ANALYSIS_RERUN: "CALL_DETAIL_ANALYSIS_RERUN",
  CALL_DETAIL_DATE: "CALL_DETAIL_DATE",
  CALL_DETAIL_DURATION: "CALL_DETAIL_DURATION",
  CALL_ANALYSIS_SCORE_VERY_HIGH: "CALL_ANALYSIS_SCORE_VERY_HIGH",
  CALL_ANALYSIS_SCORE_HIGH: "CALL_ANALYSIS_SCORE_HIGH",
  CALL_ANALYSIS_SCORE_MEDIUM: "CALL_ANALYSIS_SCORE_MEDIUM",
  CALL_ANALYSIS_SCORE_LOW: "CALL_ANALYSIS_SCORE_LOW",
  CALL_ANALYSIS_SCORE_VERY_LOW: "CALL_ANALYSIS_SCORE_VERY_LOW",
  CALL_ANALYSIS_ERROR_TECHNICAL: "CALL_ANALYSIS_ERROR_TECHNICAL",
  CALL_ANALYSIS_ERROR_USER: "CALL_ANALYSIS_ERROR_USER",
  CALL_SCORE_PAIN: "CALL_SCORE_PAIN",
  CALL_SCORE_OBJECTION: "CALL_SCORE_OBJECTION",
  CALL_SCORE_BUYING_SIGNAL: "CALL_SCORE_BUYING_SIGNAL",
  CALL_SCORE_GLOBAL: "CALL_SCORE_GLOBAL",
  CALL_ANALYSIS_EMPTY: "CALL_ANALYSIS_EMPTY",
  CALL_ANALYSIS_EMPTY_PAIN: "CALL_ANALYSIS_EMPTY_PAIN",
  CALL_ANALYSIS_EMPTY_OBJECTION: "CALL_ANALYSIS_EMPTY_OBJECTION",
  CALL_ANALYSIS_EMPTY_SIGNAL: "CALL_ANALYSIS_EMPTY_SIGNAL",
  CALL_ANALYSIS_EMPTY_VERBATIM: "CALL_ANALYSIS_EMPTY_VERBATIM",
  CALL_ANALYSIS_EMPTY_PRODUCT: "CALL_ANALYSIS_EMPTY_PRODUCT",
  CALL_ANALYSIS_EMPTY_COMPETITOR: "CALL_ANALYSIS_EMPTY_COMPETITOR",
  CALL_DETAIL_EMPTY_PAIN: "CALL_DETAIL_EMPTY_PAIN",
  CALL_DETAIL_EMPTY_OBJECTION: "CALL_DETAIL_EMPTY_OBJECTION",
  CALL_DETAIL_EMPTY_SIGNAL: "CALL_DETAIL_EMPTY_SIGNAL",
  CALL_DETAIL_EMPTY_VERBATIM: "CALL_DETAIL_EMPTY_VERBATIM",
  CALL_DETAIL_EMPTY_PRODUCT: "CALL_DETAIL_EMPTY_PRODUCT",
  CALL_DETAIL_EMPTY_COMPETITOR: "CALL_DETAIL_EMPTY_COMPETITOR",
  CALL_ANALYSIS_COUNT_SINGULAR: "CALL_ANALYSIS_COUNT_SINGULAR",
  CALL_ANALYSIS_COUNT_PLURAL: "CALL_ANALYSIS_COUNT_PLURAL",
  CALL_ANALYSIS_RECO_EVIDENCE: "CALL_ANALYSIS_RECO_EVIDENCE",
  CALL_ANALYSIS_RECO_INACTION: "CALL_ANALYSIS_RECO_INACTION",
  CALL_ANALYSIS_RECO_TODO: "CALL_ANALYSIS_RECO_TODO",
  CALL_ANALYSIS_EXPERT_AUDIT_TITLE: "CALL_ANALYSIS_EXPERT_AUDIT_TITLE",
  CALL_ANALYSIS_EXPERT_AUDIT_DESC: "CALL_ANALYSIS_EXPERT_AUDIT_DESC",
  CALL_ANALYSIS_EXPERT_AUDIT_CTA: "CALL_ANALYSIS_EXPERT_AUDIT_CTA",
  CALL_ANALYSIS_EXPERT_AUDIT_SUCCESS_TITLE: "CALL_ANALYSIS_EXPERT_AUDIT_SUCCESS_TITLE",
  CALL_ANALYSIS_EXPERT_AUDIT_SUCCESS_DESC: "CALL_ANALYSIS_EXPERT_AUDIT_SUCCESS_DESC",
  CALL_ANALYSIS_RECO_AI: "CALL_ANALYSIS_RECO_AI",
  CALL_ANALYSIS_DRIVE_ERROR_DOWNLOAD: "CALL_ANALYSIS_DRIVE_ERROR_DOWNLOAD",
  CALL_ANALYSIS_UPLOAD_ERROR_FORMAT: "CALL_ANALYSIS_UPLOAD_ERROR_FORMAT",
  CALL_ANALYSIS_UPLOAD_ERROR_SIZE: "CALL_ANALYSIS_UPLOAD_ERROR_SIZE",
  CALL_ANALYSIS_EXTRACT_AUDIO_TITLE: "CALL_ANALYSIS_EXTRACT_AUDIO_TITLE",
  CALL_ANALYSIS_EXTRACT_AUDIO_TEXT_VIDEO: "CALL_ANALYSIS_EXTRACT_AUDIO_TEXT_VIDEO",
  CALL_ANALYSIS_EXTRACT_AUDIO_TEXT_AUDIO: "CALL_ANALYSIS_EXTRACT_AUDIO_TEXT_AUDIO",
  CALL_ANALYSIS_EXTRACT_AUDIO_CONFIRM: "CALL_ANALYSIS_EXTRACT_AUDIO_CONFIRM",
  CALL_ANALYSIS_EXTRACT_AUDIO_CONFIRM_VIDEO: "CALL_ANALYSIS_EXTRACT_AUDIO_CONFIRM_VIDEO",
  CALL_ANALYSIS_EXTRACT_AUDIO_PROGRESS: "CALL_ANALYSIS_EXTRACT_AUDIO_PROGRESS",
  CALL_ANALYSIS_EXTRACT_AUDIO_PROCESSING: "CALL_ANALYSIS_EXTRACT_AUDIO_PROCESSING",
  CALL_ANALYSIS_EXTRACT_AUDIO_TOO_LARGE: "CALL_ANALYSIS_EXTRACT_AUDIO_TOO_LARGE",
  CALL_ANALYSIS_EXTRACT_AUDIO_ERROR: "CALL_ANALYSIS_EXTRACT_AUDIO_ERROR",
  CALL_ANALYSIS_PATTERN_TALK_BALANCE: "CALL_ANALYSIS_PATTERN_TALK_BALANCE",
  CALL_ANALYSIS_PATTERN_TALK_BALANCE_SUB: "CALL_ANALYSIS_PATTERN_TALK_BALANCE_SUB",
  CALL_ANALYSIS_PATTERN_PROSPECT_ENGAGEMENT: "CALL_ANALYSIS_PATTERN_PROSPECT_ENGAGEMENT",
  CALL_ANALYSIS_PATTERN_PROSPECT_ENGAGEMENT_SUB: "CALL_ANALYSIS_PATTERN_PROSPECT_ENGAGEMENT_SUB",
  CALL_ANALYSIS_PATTERN_SPEECH_CLARITY: "CALL_ANALYSIS_PATTERN_SPEECH_CLARITY",
  CALL_ANALYSIS_PATTERN_SPEECH_CLARITY_SUB: "CALL_ANALYSIS_PATTERN_SPEECH_CLARITY_SUB",
  CALL_ANALYSIS_PATTERN_NEXT_STEPS: "CALL_ANALYSIS_PATTERN_NEXT_STEPS",
  CALL_ANALYSIS_PATTERN_NEXT_STEPS_SUB: "CALL_ANALYSIS_PATTERN_NEXT_STEPS_SUB",
  CALL_ANALYSIS_PATTERN_FRICTION_MOMENTS: "CALL_ANALYSIS_PATTERN_FRICTION_MOMENTS",
  CALL_ANALYSIS_PATTERN_FRICTION_MOMENTS_SUB: "CALL_ANALYSIS_PATTERN_FRICTION_MOMENTS_SUB",
  CALL_ANALYSIS_PATTERN_EXCHANGE_TRENDS: "CALL_ANALYSIS_PATTERN_EXCHANGE_TRENDS",
  CALL_ANALYSIS_PATTERN_EXCHANGE_TRENDS_SUB: "CALL_ANALYSIS_PATTERN_EXCHANGE_TRENDS_SUB",
  CALL_ANALYSIS_INSIGHT_PERCENTAGE: "CALL_ANALYSIS_INSIGHT_PERCENTAGE",
  CALL_ANALYSIS_INSIGHT_CALLS_EMPTY: "CALL_ANALYSIS_INSIGHT_CALLS_EMPTY",
  CALL_ANALYSIS_SEE_MORE: "CALL_ANALYSIS_SEE_MORE",
  CALL_ANALYSIS_PATTERNS_EMPTY: "CALL_ANALYSIS_PATTERNS_EMPTY",
  CALL_ROW_MENU_OPEN: "CALL_ROW_MENU_OPEN",
  CALL_SCORE_MARKET_GLOBAL: "CALL_SCORE_MARKET_GLOBAL",
  CALL_SCORE_CONV_CLARITY: "CALL_SCORE_CONV_CLARITY",
  CALL_SCORE_PROSPECT_ENGAGEMENT: "CALL_SCORE_PROSPECT_ENGAGEMENT",
  CALL_SCORE_NEXT_STEP: "CALL_SCORE_NEXT_STEP",
  CALL_SCORE_CALL_GLOBAL: "CALL_SCORE_CALL_GLOBAL",
  CALL_SCORE_SECTION_MARKET: "CALL_SCORE_SECTION_MARKET",
  CALL_SCORE_SECTION_DYNAMICS: "CALL_SCORE_SECTION_DYNAMICS",
  CALL_DETAIL_TAB_SCORES: "CALL_DETAIL_TAB_SCORES",
  CALL_DETAIL_TAB_KEY_MOMENTS: "CALL_DETAIL_TAB_KEY_MOMENTS",
  CALL_DETAIL_KEY_MOMENTS_EMPTY: "CALL_DETAIL_KEY_MOMENTS_EMPTY",
  CALL_DETAIL_TAB_METRICS: "CALL_DETAIL_TAB_METRICS",
  CALL_SCORE_MARKET_GLOBAL_DESC: "CALL_SCORE_MARKET_GLOBAL_DESC",
  CALL_SCORE_CALL_GLOBAL_DESC: "CALL_SCORE_CALL_GLOBAL_DESC",
  CALL_DETAIL_META_TITLE: "CALL_DETAIL_META_TITLE",
  CALL_DETAIL_MAIN_TOPIC: "CALL_DETAIL_MAIN_TOPIC",
  CALL_DETAIL_MAIN_BLOCKER: "CALL_DETAIL_MAIN_BLOCKER",
  CALL_DETAIL_NEXT_STEP_DETECTED: "CALL_DETAIL_NEXT_STEP_DETECTED",
  CALL_KEY_MOMENT_TYPE_CONTEXT_REQUEST: "CALL_KEY_MOMENT_TYPE_CONTEXT_REQUEST",
  CALL_KEY_MOMENT_TYPE_CLARIFICATION_REQUEST: "CALL_KEY_MOMENT_TYPE_CLARIFICATION_REQUEST",
  CALL_KEY_MOMENT_TYPE_PAIN_POINT: "CALL_KEY_MOMENT_TYPE_PAIN_POINT",
  CALL_KEY_MOMENT_TYPE_BUYING_SIGNAL: "CALL_KEY_MOMENT_TYPE_BUYING_SIGNAL",
  CALL_KEY_MOMENT_TYPE_OBJECTION: "CALL_KEY_MOMENT_TYPE_OBJECTION",
  CALL_KEY_MOMENT_TYPE_FRICTION_SIGNAL: "CALL_KEY_MOMENT_TYPE_FRICTION_SIGNAL",
  CALL_KEY_MOMENT_TYPE_PRICING_TRANSITION: "CALL_KEY_MOMENT_TYPE_PRICING_TRANSITION",
  CALL_KEY_MOMENT_TYPE_MOMENTUM_SHIFT: "CALL_KEY_MOMENT_TYPE_MOMENTUM_SHIFT",
  CALL_KEY_MOMENT_TYPE_NEXT_STEP: "CALL_KEY_MOMENT_TYPE_NEXT_STEP",
  CALL_KEY_MOMENT_TYPE_FEATURE_REQUEST: "CALL_KEY_MOMENT_TYPE_FEATURE_REQUEST",
  CALL_KEY_MOMENT_TYPE_COMPETITOR_MENTION: "CALL_KEY_MOMENT_TYPE_COMPETITOR_MENTION",
  CALL_KEY_MOMENT_IMPORTANCE_CRITICAL: "CALL_KEY_MOMENT_IMPORTANCE_CRITICAL",
  CALL_KEY_MOMENT_IMPORTANCE_HIGH: "CALL_KEY_MOMENT_IMPORTANCE_HIGH",
  CALL_KEY_MOMENT_IMPORTANCE_MEDIUM: "CALL_KEY_MOMENT_IMPORTANCE_MEDIUM",
  CALL_KEY_MOMENT_IMPORTANCE_LOW: "CALL_KEY_MOMENT_IMPORTANCE_LOW",
  CALL_KEY_MOMENT_SPEAKER_FALLBACK: "CALL_KEY_MOMENT_SPEAKER_FALLBACK",
  CALL_METRICS_SECTION_QUALITY: "CALL_METRICS_SECTION_QUALITY",
  CALL_METRICS_SECTION_OVERVIEW: "CALL_METRICS_SECTION_OVERVIEW",
  CALL_METRICS_SECTION_SPEAKERS: "CALL_METRICS_SECTION_SPEAKERS",
  CALL_METRICS_LABEL_TALK_BALANCE: "CALL_METRICS_LABEL_TALK_BALANCE",
  CALL_METRICS_LABEL_ENGAGEMENT: "CALL_METRICS_LABEL_ENGAGEMENT",
  CALL_METRICS_LABEL_CLARITY: "CALL_METRICS_LABEL_CLARITY",
  CALL_METRICS_LABEL_NEXT_STEP: "CALL_METRICS_LABEL_NEXT_STEP",
  CALL_METRICS_STAT_DURATION: "CALL_METRICS_STAT_DURATION",
  CALL_METRICS_STAT_TURNS: "CALL_METRICS_STAT_TURNS",
  CALL_METRICS_STAT_SPEAKERS: "CALL_METRICS_STAT_SPEAKERS",
  CALL_METRICS_STAT_QUESTIONS: "CALL_METRICS_STAT_QUESTIONS",
  CALL_METRICS_STAT_INTERRUPTIONS: "CALL_METRICS_STAT_INTERRUPTIONS",
  CALL_METRICS_STAT_CLARIFICATIONS: "CALL_METRICS_STAT_CLARIFICATIONS",
  CALL_METRICS_STAT_TURNS_SHORT: "CALL_METRICS_STAT_TURNS_SHORT",
  CALL_METRICS_STAT_WORDS_PER_TURN: "CALL_METRICS_STAT_WORDS_PER_TURN",
  CALL_METRICS_STAT_WORDS_PER_MIN: "CALL_METRICS_STAT_WORDS_PER_MIN",
  CALL_METRICS_STAT_QUESTIONS_SHORT: "CALL_METRICS_STAT_QUESTIONS_SHORT",
  CALL_METRICS_STAT_CLARIFICATIONS_SHORT: "CALL_METRICS_STAT_CLARIFICATIONS_SHORT",
  CALL_METRICS_STATUS_SELLER_DOMINANT: "CALL_METRICS_STATUS_SELLER_DOMINANT",
  CALL_METRICS_STATUS_PROSPECT_DOMINANT: "CALL_METRICS_STATUS_PROSPECT_DOMINANT",
  CALL_METRICS_STATUS_BALANCED: "CALL_METRICS_STATUS_BALANCED",
  CALL_METRICS_STATUS_SLIGHTLY_UNBALANCED: "CALL_METRICS_STATUS_SLIGHTLY_UNBALANCED",
  CALL_METRICS_STATUS_HIGH: "CALL_METRICS_STATUS_HIGH",
  CALL_METRICS_STATUS_MEDIUM: "CALL_METRICS_STATUS_MEDIUM",
  CALL_METRICS_STATUS_LOW: "CALL_METRICS_STATUS_LOW",
  CALL_METRICS_STATUS_VERY_LOW: "CALL_METRICS_STATUS_VERY_LOW",
  CALL_METRICS_STATUS_UNCLEAR: "CALL_METRICS_STATUS_UNCLEAR",
  CALL_METRICS_STATUS_CLEAR: "CALL_METRICS_STATUS_CLEAR",
  CALL_METRICS_STATUS_PARTIAL: "CALL_METRICS_STATUS_PARTIAL",
  CALL_METRICS_STATUS_WEAK: "CALL_METRICS_STATUS_WEAK",
  CALL_METRICS_STATUS_ABSENT: "CALL_METRICS_STATUS_ABSENT",
  CALL_METRICS_ROLE_SELLER: "CALL_METRICS_ROLE_SELLER",
  CALL_METRICS_ROLE_PROSPECT: "CALL_METRICS_ROLE_PROSPECT",
  CALL_METRICS_ROLE_CUSTOMER: "CALL_METRICS_ROLE_CUSTOMER",
  CALL_METRICS_ROLE_HOST: "CALL_METRICS_ROLE_HOST",
  CALL_METRICS_ROLE_GUEST: "CALL_METRICS_ROLE_GUEST",
  CALL_METRICS_ROLE_UNKNOWN: "CALL_METRICS_ROLE_UNKNOWN",
  CALL_METRICS_SPEAKER_FALLBACK: "CALL_METRICS_SPEAKER_FALLBACK",
  CALL_ANALYSIS_AUTO_RUN: "CALL_ANALYSIS_AUTO_RUN",
  CALL_ANALYSIS_AUTO_RUN_MODAL_TITLE: "CALL_ANALYSIS_AUTO_RUN_MODAL_TITLE",
  CALL_ANALYSIS_AUTO_RUN_MODAL_DESC: "CALL_ANALYSIS_AUTO_RUN_MODAL_DESC",
  CALL_ANALYSIS_AUTO_RUN_ROLES: "CALL_ANALYSIS_AUTO_RUN_ROLES",
  CALL_ANALYSIS_AUTO_RUN_MODAL_CONFIRM: "CALL_ANALYSIS_AUTO_RUN_MODAL_CONFIRM",
  CALL_EXPORT_TITLE: "CALL_EXPORT_TITLE",
  CALL_EXPORT_FORMAT: "CALL_EXPORT_FORMAT",
  CALL_EXPORT_OPTIONS: "CALL_EXPORT_OPTIONS",
  CALL_EXPORT_TRANSCRIPT: "CALL_EXPORT_TRANSCRIPT",
  CALL_EXPORT_METRICS: "CALL_EXPORT_METRICS",
  CALL_EXPORT_KEY_MOMENTS: "CALL_EXPORT_KEY_MOMENTS",
  CALL_EXPORT_PAIN_POINTS: "CALL_EXPORT_PAIN_POINTS",
  CALL_EXPORT_OBJECTIONS: "CALL_EXPORT_OBJECTIONS",
  CALL_EXPORT_BUYING_SIGNALS: "CALL_EXPORT_BUYING_SIGNALS",
  CALL_EXPORT_VERBATIMS: "CALL_EXPORT_VERBATIMS",
  CALL_EXPORT_PRODUCT_REQUESTS: "CALL_EXPORT_PRODUCT_REQUESTS",
  CALL_EXPORT_COMPETITORS: "CALL_EXPORT_COMPETITORS",
  CALL_EXPORT_PATTERNS: "CALL_EXPORT_PATTERNS",
  CALL_EXPORT_SUBMIT: "CALL_EXPORT_SUBMIT",
  CALL_EXPORT_CALL_SUBMIT: "CALL_EXPORT_CALL_SUBMIT",
  CALL_EXPORT_INSIGHTS_TITLE: "CALL_EXPORT_INSIGHTS_TITLE",
  CALL_EXPORT_ANALYZED_BY: "CALL_EXPORT_ANALYZED_BY",
  CALL_EXPORT_CALL_SINGLE: "CALL_EXPORT_CALL_SINGLE",
  CALL_EXPORT_CALL_PLURAL: "CALL_EXPORT_CALL_PLURAL",
  CALL_ANALYSIS_NA: "CALL_ANALYSIS_NA",
  CALL_ANALYSIS_INSIGHT_EXCLUDED: "CALL_ANALYSIS_INSIGHT_EXCLUDED",
  CALL_ANALYSIS_EXCLUDE_TITLE: "CALL_ANALYSIS_EXCLUDE_TITLE",
  CALL_ANALYSIS_EXCLUDE_DESC: "CALL_ANALYSIS_EXCLUDE_DESC",
  CALL_ANALYSIS_EXCLUDE_CTA: "CALL_ANALYSIS_EXCLUDE_CTA",
  CALL_ANALYSIS_RECOUNT_TITLE: "CALL_ANALYSIS_RECOUNT_TITLE",
  CALL_ANALYSIS_RECOUNT_DESC: "CALL_ANALYSIS_RECOUNT_DESC",
  CALL_ANALYSIS_RECOUNT_CTA: "CALL_ANALYSIS_RECOUNT_CTA",
  CALL_ANALYSIS_RECOUNTING: "CALL_ANALYSIS_RECOUNTING",
  CALL_ANALYSIS_EXCLUDE_TOOLTIP: "CALL_ANALYSIS_EXCLUDE_TOOLTIP",
  CALL_ANALYSIS_RECOUNT_TOOLTIP: "CALL_ANALYSIS_RECOUNT_TOOLTIP",
} as const;
